import React, { FC } from 'react';
import { CustomTexts } from '@plus-int/acq-toolkit';

import styles from './PayVia.module.css';

interface PayViaProps {
    texts: Partial<CustomTexts> | undefined;
    hasPmsConfigs: boolean;
    onClick: () => void;
}

const getPaymentIcons = (
    texts: Partial<CustomTexts> | undefined,
    hasPmsConfigs: boolean
): string[] => {
    if (!hasPmsConfigs && !texts) {
        return [];
    }

    const iconPrefix = 'pms';
    const textsEntries = texts
        ? Object.entries(texts).filter(
              ([key, value]) => key.startsWith(iconPrefix) && typeof value === 'string'
          )
        : [];

    return textsEntries
        .map(([key, value]) => ({
            num: parseInt(key.replace(iconPrefix, ''), 10),
            value: value as string,
        }))
        .sort((a, b) => a.num - b.num)
        .map((item) => item.value);
};

export const PayVia: FC<PayViaProps> = ({ texts, onClick, hasPmsConfigs }) => {
    const paymentMethodsIcons = getPaymentIcons(texts, hasPmsConfigs);

    return (
        <div className={styles.root} onClick={onClick} role="presentation">
            {paymentMethodsIcons.map((icon) => (
                <img key={icon} src={icon} alt="" className={styles.paymentIcon} />
            ))}
        </div>
    );
};
